import type { InputProps, InputRef } from 'antd';

import { INPUT_MASKS } from '@/shared/constants';

import MaskedInput from '../masked-input';

/** Цифр в номере Казахстана без кода страны. */
const LOCAL_DIGITS = 10;

/**
 * Сырой ввод → цифры номера без кода страны. Вставленный целиком номер
 * (`+7 707 …`, `8 707 …`, `7707…`) теряет ведущие 7/8, при обычном наборе цифры не трогаем.
 */
const normalizePhone = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '');
  return digits.length > LOCAL_DIGITS && /^[78]/.test(digits)
    ? digits.slice(1)
    : digits;
};

interface IProps extends Omit<
  InputProps,
  'value' | 'onChange' | 'defaultValue' | 'prefix'
> {
  /** Номер без маски: 11 цифр, начиная с 7 (`77071234567`), или пустая строка. */
  value?: string;
  onChange?: (value: string) => void;
  ref?: React.Ref<InputRef>;
}

/** Ввод телефона Казахстана: «+7» — префикс поля, маской вводятся 10 цифр номера. */
const PhoneInput: React.FC<IProps> = ({
  value = '',
  onChange,
  ...inputProps
}) => (
  <MaskedInput
    {...inputProps}
    type="tel"
    autoComplete={inputProps.autoComplete ?? 'tel-national'}
    prefix="+7"
    mask={INPUT_MASKS.phoneLocal}
    normalize={normalizePhone}
    value={value.replace(/^7/, '')}
    onChange={(digits) => onChange?.(digits ? `7${digits}` : '')}
  />
);

export default PhoneInput;
